module.exports = __webpack_public_path__ + "img/imgs11.55302b58.png";